<template>
  <v-container
    class="scrollable-container"
    grid-list-lg
    d-flex
    fluid
  >
    <slot />
  </v-container>
</template>

<script>
  export default {
    name: 'ScrollableContainer'
  }
</script>

<style lang="scss">
  .scrollable-container {
    overflow-x: auto;
  }
</style>
